import userService from 'resources/user/user.service';
import dealService from 'resources/deal/deal.service';
import companyService from 'resources/company/company.service';

import { DEAL_STAGES, DEAL_STATUSES } from 'resources/deal/deal.constants';

import { generateTransactionListedKit } from 'resources/listedkit/workflows/generateTransactionListedKit';

import { finishTransaction } from './finishTransaction';
import { updateDealClients } from './updateDealClients';
import { editTransactionDetails } from './editTransactionDetails';

const voidSampleDeal = async (realtorId) => {
  const sampleDeal = await dealService.getSampleDealByRealtorId(realtorId);

  if (sampleDeal && sampleDeal.status !== DEAL_STATUSES.VOIDED) {
    await finishTransaction(sampleDeal, DEAL_STATUSES.VOIDED);

    await userService.remove({ id: sampleDeal.client_ids[0] });
  }
};

export const dealStageMapToStatus = {
  [DEAL_STAGES.UNDER_CONTRACT]: DEAL_STATUSES.ACTIVE,
  [DEAL_STAGES.PRE_CONTRACT_ACTIVE_LISTING]: DEAL_STATUSES.ACTIVE_LISTING,
};

const createDeal = async ({
  dealType,
  dealStage,
  realtorId,
  coordinatorId,
  companyId,
  clientIds,
  transactionDetails,
  milestonesWithTasks,
  isSample,
  eSignDocuments, // comes from transactionData <- fillInTransactionData
  createTransactionDocuments,
}) => {
  await voidSampleDeal(realtorId);

  const company = await companyService.findById(companyId);

  let deal = await dealService.createDeal({
    type: dealType,
    realtorId,
    coordinatorId,
    company,
    isSample,
  });

  await updateDealClients({ clientIds, deal });
  deal.client_ids = clientIds;

  if (dealStage && transactionDetails) {
    deal = await editTransactionDetails({
      dealId: deal.id,
      transactionDetails,
      status: dealStageMapToStatus[dealStage],
    });
  }

  const createdListedKit = await generateTransactionListedKit({
    deal,
    dealStage,
    milestonesWithTasks,
  });

  if (eSignDocuments?.length) {
    await createTransactionDocuments({
      documentIds: eSignDocuments.map((doc) => doc.id),
      listedKitId: createdListedKit.id,
      dealId: deal.id,
    });
  }

  return dealService.findById(deal.id);
};

export {
  createDeal,
};
